'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionDonutSmall = function ActionDonutSmall(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11 9.16V2c-5 .5-9 4.79-9 10s4 9.5 9 10v-7.16c-1-.41-2-1.52-2-2.84s1-2.43 2-2.84zM14.86 11H22c-.48-4.75-4-8.53-9-9v7.16c1 .3 1.52.98 1.86 1.84zM13 14.84V22c5-.47 8.52-4.25 9-9h-7.14c-.34.86-.86 1.54-1.86 1.84z' })
  );
};
ActionDonutSmall = (0, _pure2.default)(ActionDonutSmall);
ActionDonutSmall.displayName = 'ActionDonutSmall';
ActionDonutSmall.muiName = 'SvgIcon';

exports.default = ActionDonutSmall;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/action/donut-small.js
 ** module id = 1473
 ** module chunks = 0
 **/